import React, { useState } from 'react'
import IssueFinalDecisionModal from 'components/rounds/modals/IssueFinalDecisionModal'

const MODAL_ID = 'issue-final-decision'

export default function IssueDecisionButton({ packageId, content }) {
  const [recipients, setRecipients] = useState(null)

  const openModal = () => window.dispatchEvent(new Event(`openModal-${MODAL_ID}`))
  const triggerLabel = content?.triggerLabel || 'issue decision'

  return (
    <>
      <button
        type="button"
        className="dome-btn dome-btn-base dome-btn-dark-green"
        onClick={openModal}
      >
        {triggerLabel}
      </button>

      <IssueFinalDecisionModal
        packageId={packageId}
        onSuccess={setRecipients}
        recipients={recipients}
        content={content}
      />
    </>
  )
}
